import DOMPurify from 'dompurify'
import { marked } from 'marked'

interface MarkdownProps {
  source: string
  className?: string
}

/**
 * Renders the agent's markdown (headers, GFM tables, lists, bold, links, rules) as sanitized HTML.
 * The agent emits its summaries as markdown; rendering them as a plain string collapsed everything onto
 * one line. marked@4 is synchronous with GFM (incl. pipe tables) on by default; DOMPurify scrubs any
 * unsafe HTML that document-derived text might carry before it reaches the DOM.
 */
export function Markdown({ source, className }: Readonly<MarkdownProps>) {
  const html = DOMPurify.sanitize(marked.parse(source ?? '') as string)
  return (
    <div
      className={`copilot-md${className ? ` ${className}` : ''}`}
      // eslint-disable-next-line react/no-danger -- sanitized above with DOMPurify
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}
